import(/* webpackMode: "eager" */ "/tmp/8def487d286dae1/app/global-error.tsx");
